/**
 * @generated SignedSource<<ea61456f8d6a98ed71d6884ba989418f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ChatDeleteHardMutation$variables = {
  rowId: any;
};
export type ChatDeleteHardMutation$data = {
  readonly deleteChatByRowId: {
    readonly deletedChatId: string | null;
  } | null;
};
export type ChatDeleteHardMutation = {
  variables: ChatDeleteHardMutation$variables;
  response: ChatDeleteHardMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rowId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "rowId",
            "variableName": "rowId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "DeleteChatPayload",
    "kind": "LinkedField",
    "name": "deleteChatByRowId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedChatId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatDeleteHardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatDeleteHardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "748fa44afde5ab86c847a0ea18aa95a4",
    "id": null,
    "metadata": {},
    "name": "ChatDeleteHardMutation",
    "operationKind": "mutation",
    "text": "mutation ChatDeleteHardMutation(\n  $rowId: UUID!\n) {\n  deleteChatByRowId(input: {rowId: $rowId}) {\n    deletedChatId\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc7122982849874c4ac8c605aead62e8";

export default node;
